export default "__VITE_ASSET__xVDp3wjd__"